import React from 'react';
import _ from 'lodash';

import { useTranslation } from '../../localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { closeButton } from './ModalButtons';

const ViewModal = ({ title, icon, isLoading, Component = null, onClose, header = null, footer = null, variant = ModalVariant.small }) => {
  const T = useTranslation();
  return (
    (Component) ?
      <Modal
        variant={variant}
        header={header}
        footer={footer}
        title={title}
        titleIconVariant={icon}
        isOpen={!_.isEmpty(Component)}
        onClose={isLoading ? null : onClose}
        actions={closeButton({ T, onClose, isLoading })}
      >
        { Component }
      </Modal>
      : <></>
  );
};

export default React.memo(ViewModal);
